import { render } from "./charade.vue?vue&type=template&id=cc4c2fc6&scoped=true"
import script from "./charade.vue?vue&type=script&lang=js"
export * from "./charade.vue?vue&type=script&lang=js"

import "./charade.vue?vue&type=style&index=0&id=cc4c2fc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc4c2fc6"]])

export default __exports__